import axios from "axios";
import {CONTRACT_CANCELLATION_PATH} from "../api/endpointPaths.mjs";
import type {ContractCancellationRequestBody} from "./contractCancellation";

/**
 * What the api answers a § 312k cancellation declaration with (kitecorp/transferify-ui#2327).
 *
 * <p><strong>One field, and that is a security property rather than a thin response.</strong> The api
 * deliberately does not say whether the address matched an account or a live subscription: this endpoint is
 * anonymous, so an outcome in the response body would make it an account-enumeration oracle anybody could
 * walk an address list through. What happened reaches the consumer in the confirmation email, which goes to
 * the address itself.
 *
 * @property receivedAt the server's own receipt moment, ISO-8601 in UTC. § 312k Abs. 4 obliges us to confirm
 *   the date AND time the declaration arrived, and Abs. 4 S. 2 presumes it arrived immediately on the button
 *   press — so this is the moment the whole flow is dated from, and never the browser's clock.
 */
export interface ContractCancellationReceipt {
	receivedAt: string;
}

/** The anonymous § 312k cancellation declaration. Resolves on 2xx, rejects on any transport/HTTP error. */
export class ContractCancellationApi {
	static async declare(body: ContractCancellationRequestBody): Promise<ContractCancellationReceipt> {
		const {data} = await axios.post<unknown, {data: ContractCancellationReceipt}>(
			CONTRACT_CANCELLATION_PATH, body);
		return data;
	}
}
